import { Button, Icon } from "@growtherapy/sprout-ui";
import { useTranslate } from "@growtherapy/i18n";
import { twMerge } from "tailwind-merge";
import {
  ANIMATION_ACTION_ICONS,
  getNextAction,
  useAnimationState,
} from "./useAnimationState";
import { ActionType, ActionStateToggleButtonProps } from "./types";
import { TFunction } from "i18next";

function getAnimationAriaLabel(t: TFunction, actionType: ActionType): string {
  switch (actionType) {
    case ActionType.PLAY:
      return t("telehealth-core:waitingRoom.playBackgroundAnimation");
    case ActionType.PAUSE:
      return t("telehealth-core:waitingRoom.pauseBackgroundAnimation");
  }
}

function getAnimationLabel(t: TFunction, actionType: ActionType): string {
  switch (actionType) {
    case ActionType.PLAY:
      return t("telehealth-core:waitingRoom.playAnimation");
    case ActionType.PAUSE:
      return t("telehealth-core:waitingRoom.pauseAnimation");
  }
}

export function AnimationStateToggleButton({
  className,
  currentActionState,
  onClick,
}: ActionStateToggleButtonProps): JSX.Element {
  const t = useTranslate();
  const nextActionName = getNextAction(currentActionState);
  const nextActionIcon = ANIMATION_ACTION_ICONS[nextActionName];
  return (
    <Button
      use="link"
      size="sm"
      className={twMerge(
        "flex gap-x-2 items-center text-yellow-700 no-underline hover:brightness-75 hover:text-yellow-700",
        className,
      )}
      onClick={() => onClick()}
      aria-label={getAnimationAriaLabel(t, nextActionName)}
    >
      <Icon icon={nextActionIcon} />
      {getAnimationLabel(t, nextActionName)}
    </Button>
  );
}

export type AnimationStateToggleButtonWrapperProps = Pick<
  ActionStateToggleButtonProps,
  "className"
>;

export function AnimationStateToggleButtonWrapper(
  props: AnimationStateToggleButtonWrapperProps,
) {
  const { currentState, toggle } = useAnimationState();

  return (
    <AnimationStateToggleButton
      {...props}
      currentActionState={currentState}
      onClick={toggle}
    />
  );
}
